import { faBook } from "@fortawesome/free-solid-svg-icons";
import { ContainerWithHeaderAndMenu } from "../menuandheader/ContainerWithHeaderAndMenu";
import { SongbookManagement } from "./SongbookManagement";
import { useParams } from "react-router-dom";
import { bucketParamKey } from "../items/Items";
import { useTranslation } from "react-i18next";

export function ManageSongbooks() {
  const { t } = useTranslation();
  const params = useParams();
  const bucket = params[bucketParamKey];

  return (
    <ContainerWithHeaderAndMenu icon={faBook} title={t("songbooks.title")}>
      <p>{t("songbooks.description")}</p>

      {bucket && <SongbookManagement bucket={bucket} />}
    </ContainerWithHeaderAndMenu>
  );
}
